export enum PROMPT_TYPE {
  TELEPROPTER_SCRIPT = 'Teleprompter Script',
  EMAIL = 'Email',
  SMS = 'SMS',
  CRM_MESSAGE = 'CRM Message',
}

export enum PROMPT_USE_CASE {
  INITIAL_REACH_OUT = 'Initial Reach Out',
  INITIAL_INQUIRY_REPLY = 'Initial Inquiry Reply',
  VEHICLE_WALKAROUND = 'Vehicle Walkaround',
  TEST_DRIVE_INVITATION = 'Test Drive Invitation',
  APPOINTMENT_REMINDER = 'Appointment Reminder',
  MISSED_APPOINTMENT = 'Missed Appointment',
  UNSOLD_FOLLOW_UP = 'Unsold Follow Up',
  EVENT_PROMOTION_ALERT = 'Event & Promotion Alert',
  POST_SALE_FOLLOW_UP = 'Post-Sale Follow-Up',
  REVIEW_REFERRAL_REQUEST = 'Review or Referral Request',
  SERVICE_MAINTENANCE_REMINDERS = 'Service and Maintenance Reminders',
  NONE = '',
}

export enum DETAIL_LEVEL {
  LOW,
  LOW_TO_MID,
  MID,
  MID_TO_HIGH,
  HIGH,
}

export enum FORMALITY_LEVEL {
  LOW,
  LOW_TO_MID,
  MID,
  MID_TO_HIGH,
  HIGH,
}

export enum ENTHUSIASM_LEVEL {
  LOW,
  LOW_TO_MID,
  MID,
  MID_TO_HIGH,
  HIGH,
}

export const promptUseCaseOptions = Object.values(PROMPT_USE_CASE).map(
  (option) => ({
    value: option,
    label: option,
  })
);

export enum GPT_RESULT_TEXT_TYPE {
  PLAIN,
  HTML,
}

export type Option = {
  value: string | number;
  label: string | number;
};

export enum LandingPageType {
  VIDMAILS = 'vidmails',
  AUTOMOTIVE = 'automotive',
}

export type LandingPageOption = {
  value: string | number;
  label: string;
  landingPageType: LandingPageType;
};

export type CrmData = {
  data: {
    shortUrlCode: string;
    html: string;
    url: string;
    thumbnail: string;
  };
};

export interface GenerateTextParams {
  promptType: PROMPT_TYPE;
  promptUseCase: PROMPT_USE_CASE;
  formalityLevel: FORMALITY_LEVEL;
  enthusiasmLevel: ENTHUSIASM_LEVEL;
  detailLevel: DETAIL_LEVEL;
  baseText?: string;
  recipient?: string;
  additionalInfo?: string;
  callToAction?: string;
  sender?: string;
  senderCompany?: string;
  vehicleTitle?: string;
  vin?: string;
  videoId?: number | string;
}

export type WebsiteOverlay = {
  id: number;
  url: string;
  title: string;
  defaultflag: 0 | 1;
  fileThumbnail: string;
  fileTitle: string;
  type: string;
  itemType: string;
};

export type GetWebsiteOverlaysResponse = {
  websiteUrls: WebsiteOverlay[];
  default: WebsiteOverlay;
  count: number;
};

export type LandingPage = {
  id: number;
  title: string;
  thumbnailURL: string;
  typeId?: number;
  landingPage?: {
    [key: string]: any;
  };
};

export type GetLandingPagesResponse = {
  templates: LandingPage[];
  default: LandingPage;
  count: number;
};

export type GetQuickshareParams = {
  templateId?: number | string;
  linksetId?: number | string;
  overlayId?: number | string;
  iconId?: number | string;
  vin?: number | string;
  format?: string;
  useAutomotive?: string | boolean | undefined;
  allowVideoReply?: string | boolean | undefined;
  allowReactions?: string | boolean | undefined;
  notifyUser?: string | boolean | undefined;
};

export type ValidTinyInt = 0 | 1;

export type CustomerAndUserIds = {
  customerId: number;
  userId: number;
};

export type CTA = CustomerAndUserIds & {
  id: number;
  ctaSetId: number;
  type: string;
  linkText: string;
  linkValue: string;
  autoOpen: boolean;
  linkPosition: number;
  newWindow: ValidTinyInt;
  fileTitle: string;
  fileThumbnail: string;
  itemType: string;
};
export type CTASet = CustomerAndUserIds & {
  id: number;
  company: ValidTinyInt;
  title: string;
  defaultLinks: ValidTinyInt;
  links: CTA[];
};

export type GetCtaSetResponse = {
  linksets: CTASet[];
  default: CTASet;
};

export type GetLandingPagesParams = {
  search?: string;
  start?: number;
  limit?: number;
  showUserCustomLandingPages?: boolean;
};

export interface GenerateTextParams {
  promptType: PROMPT_TYPE;
  promptUseCase: PROMPT_USE_CASE;
  formalityLevel: FORMALITY_LEVEL;
  enthusiasmLevel: ENTHUSIASM_LEVEL;
  detailLevel: DETAIL_LEVEL;
  baseText?: string;
  recipient?: string;
  additionalInfo?: string;
  callToAction?: string;
  sender?: string;
  senderCompany?: string;
  vehicleTitle?: string;
  vin?: string;
  videoId?: number | string;
}

export type GetWebsiteOverlaysParams = GetLandingPagesParams;

export type GetCtaSetParams = {
  search?: string;
  start?: number;
  limit?: number;
};

export type InventoryItemMedia = {
  inventoryItemMediaId: string;
  itemId: string;
  mediaType: number;
  mediaSource: string;
};

export type InventoryItem = {
  itemId: string;
  customerId: string;
  sold: boolean;
  detailsPageUrl: string;
  price: string;
  title: string;
  vin: string;
  stockNumber: string;
  itemCondition: string;
  engine: string;
  make: string;
  model: string;
  trim: string;
  year: string;
  mileage: string;
  exteriorColor: string;
  interiorColor: string;
  transmission: string;
  createdAt: Date;
  media?: InventoryItemMedia[];
  videosRecorded?: number | string;
  videoRequests?: any[];
};

export type InventoryParams = {
  size?: number;
  page?: number;
  sort?: string;
  searchQuery?: string;
  soldFilter?: string;
  videosRecordedFilter?: string;
  countRecorded?: boolean;
  enabled?: boolean;
};

export type GetInventoryParams = {
  search?: string;
  start?: number;
  limit?: number;
  sort?: string;
  soldFilter?: string;
  videosRecordedFilter?: string;
  countRecorded?: boolean;
};

export type TypeAIAssistTheme = 'covideo' | 'automotive';
